import React from 'react';
import fr from 'facet-rest';
import { pick } from 'Helpers/Affordances';
import PrimaryActionLinkButton from 'Components/ComponentLibrary/Organisms/PrimaryActionLinkButton';
import useEventTrackingLogEvent, { categories, eventTypes } from 'EventTracking/useEventTrackingLogEvent';
import history from 'State/history';
import { dashboardUri } from 'Consts/clientUris';
import ScheduleMeetingInChiliPiperButton
  from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/OnboardingScheduleMeeting/PrimaryActionButtonPicker/ScheduleMeetingInChiliPiperButton';
import { useSnackbarContext } from 'Context/SnackbarContext';
import { useSurveyContext } from 'Views/Onboarding/Pages/Survey/SurveyContext';
import ScheduleMeetingButton from './ScheduleMeetingButton';

const MeetingInformationButtonPicker = ({
  resource,
}) => {
  const { logStandardizedEvent } = useEventTrackingLogEvent();
  const { displayErrorMessage } = useSnackbarContext();
  const { setOnboardingStepCollection } = useSurveyContext();

  const doRedirect = async () => {
    try {
      const redirectOnCloseRel = resource.withRelationship(fr.relationships.redirectOnClose.name, (rel) => {
        return rel;
      }, () => null);

      if (redirectOnCloseRel) {
        const newStep = await resource.relationship(fr.relationships.redirectOnClose.name).link('related').get();
        setOnboardingStepCollection(newStep);
        return;
      }

      history.push(dashboardUri);
    } catch (e) {
      if (e.errors) {
        displayErrorMessage(e, e.errors);
      } else {
        displayErrorMessage(e, 'Failed to redirect to next onboarding step');
      }
    }
  };

  return pick(resource, {
    [fr.relationships.waitlistScheduleChiliPiperMeeting.name]: (
      <PrimaryActionLinkButton
        relationship={resource.relationship(fr.relationships.waitlistScheduleChiliPiperMeeting.name)}
        onClick={() => {
          logStandardizedEvent(categories.digitalOnboarding, eventTypes.clickButton, 'clicking waitlist schedule button', { eventProperties: { description: 'schedule outreach with mx' } });
          history.push(dashboardUri);
        }}
        test={'waitlist-schedule-button'}
      />
    ),
    [fr.relationships.scheduleMeetingWithMx.name]: (
      <ScheduleMeetingInChiliPiperButton resource={resource} onRedirect={() => doRedirect()} size={'lg'} scheduleChiliPiperMeetingRelationship={resource.relationship(fr.relationships.scheduleMeetingWithMx.name)} />
    ),
    [fr.relationships.scheduleMeetingWithConcierge.name]:
  <ScheduleMeetingInChiliPiperButton resource={resource} onRedirect={() => doRedirect()} scheduleChiliPiperMeetingRelationship={resource.relationship(fr.relationships.scheduleMeetingWithConcierge.name)} />,
    [fr.relationships.scheduleMeetingWithPlanner.name]: (
      <ScheduleMeetingButton
        relationship={resource.relationship(fr.relationships.scheduleMeetingWithPlanner.name)}
      />
    ),
  }, null);
};

export default MeetingInformationButtonPicker;
